import React, { useEffect, useState } from "react";
import { BiLoaderAlt } from "react-icons/bi";
import { useParams } from "react-router-dom";
import { connect } from "react-redux";
import MetaHead from "../../../Common/Metahead";
import { useTranslation } from "react-i18next";
import { outReachDetails } from "../../../../stores/actions/outreach.actions.types"; // Redux action
import UpdateOutReachForm from "../../../Forms/UpdateOutReachForm";

const UpdateOutreachPage = ({ outReachDetails }) => {
  const { t } = useTranslation();
  const { id } = useParams();
  const [outreach, setOutreach] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (id) {
      setLoading(true);
      outReachDetails({
        id,
        callback: (data) => {
          if (data?.success) {
            setOutreach(data?.data?.data);
            setLoading(false);
          }
        },
      });
    }
  }, [id, outReachDetails]);

  if (loading) {
    return (
      <div className='flex m-6 dark:bg-boxdark rounded-[10px] bg-white items-center justify-center min-h-96'>
        <BiLoaderAlt className='animate-spin text-4xl text-primary dark:text-white' />
      </div>
    );
  }

  return (
    <div>
      <MetaHead title={t("update-outreach")} />
      <UpdateOutReachForm outreach={outreach} />
    </div>
  );
};

const mapStateToProps = (state) => ({ loading: state?.app?.visible });

export default connect(mapStateToProps, { outReachDetails })(
  UpdateOutreachPage
);
